import React from "react";
import { Button, Card, Col, Placeholder, Row } from "react-bootstrap";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { formatToUSDateTime } from "../../utils/dateFormat";
import { RxShare1 } from "react-icons/rx";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";
const EventCard = ({ isLoading, item, isMember }) => {
  return (
    <>
      {isLoading ? (
        <>
          <Col lg={4} md={6} sm={12}>
            <Card className="h-100 shadow-sm skeleton-card">
              <Skeleton
                height={180}
                width={"100%"}
                style={{ display: "block", margin: 0, padding: 0 }}
              />

              <Card.Body>
                <Placeholder as={Card.Title} animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>

                <Placeholder as={Card.Text} animation="glow">
                  <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                  <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                  <Placeholder xs={8} />
                </Placeholder>

                <Row className="mt-3 d-flex align-items-center justify-content-evenly g-2">
                  <Col xs={5}>
                    <Placeholder.Button
                      variant="warning"
                      className="w-100 py-2"
                    />
                  </Col>

                  <Col xs={5}>
                    <Placeholder.Button
                      variant="warning"
                      className="w-100 py-2"
                    />
                  </Col>

                  <Col xs={2}>
                    <Placeholder.Button
                      variant="warning"
                      className="w-100 py-2"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </>
      ) : (
        <>
          <Col key={item._id} lg={4} md={6} sm={12}>
            <Card className="rsvp-card h-100">
              <Card.Img
                className="rsvp-card-img"
                variant="top"
                src={`${IMAGE_BASEURL}${item?.image_path}`}
                alt={item?.title || "Event Image"}
              />

              <Card.Body className="d-flex flex-column h-100 py-3">
                <div className="flex-grow-1">
                  <Card.Title className="fw-bold mb-2">
                    {item?.title}
                  </Card.Title>

                  {isMember ? (
                    <Card.Text className="text-warning mb-2">
                      Ticket Price: <del style={{color: "#000000"}}>${item?.price}</del> $0 <span style={{color: "#77787B"}}>(Member Benefit)</span>
                    </Card.Text>
                  ) : (
                    <Card.Text className="text-warning mb-2">
                      Ticket start from ${item?.price}
                    </Card.Text>
                  )}

                  <Card.Text className="mb-2">{item?.description}</Card.Text>

                  <Card.Text className="d-flex align-items-center mb-2 mt-3">
                    <FaRegClock size={16} />
                    <span className="ms-2">
                      {formatToUSDateTime(item?.start_date)}
                      {item?.end_date && (
                        <> - {formatToUSDateTime(item?.end_date)}</>
                      )}
                    </span>
                  </Card.Text>

                  <Card.Text className="d-flex align-items-center mb-2">
                    <HiOutlineLocationMarker size={16} />
                    <span className="ms-2">{item?.venue || "N/A"}</span>
                  </Card.Text>
                </div>

                <Row className="mt-1 g-3 align-items-center">
                  <Col xs={5}>
                    <Button
                      className="w-100 py-2 px-0 btn btn-orange"
                      
                    >
                      Buy Tickets
                    </Button>
                  </Col>

                  <Col xs={5}>
                    <Button
                      className="w-100 py-2 px-0 btn btn-black"
                    >
                      RSVP
                    </Button>
                  </Col>

                  <Col
                    xs={2}
                    className="d-flex justify-content-center border rounded"
                    style={{ padding: "10px 0px", borderColor: "#D0D5DD" }}
                  >
                    <a
                      href="#"
                      className="d-flex justify-content-center align-items-center w-100"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      <RxShare1 style={{ color: "#77787B" }} />
                    </a>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </>
      )}
    </>
  );
};

export default EventCard;
